import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { ApplyCoaTemplateEntityColumn } from "./applyCoaTemplateEntitySelectionViewConfig";

export const defaultApplyCoaEntitySelectionView: View = {
    type: ViewType.CHART_OF_ACCOUNTS_TEMPLATE_APPLY,
    columns: [
        { id: ApplyCoaTemplateEntityColumn.NAME, options: { pin: "left" } },
        { id: ApplyCoaTemplateEntityColumn.INDUSTRY },
        { id: ApplyCoaTemplateEntityColumn.LAST_UPDATED },
        { id: ApplyCoaTemplateEntityColumn.TEAM },
        { id: ApplyCoaTemplateEntityColumn.SERVICES },
        { id: ApplyCoaTemplateEntityColumn.BASIS },
    ],
    filters: {},
    options: {
        // `selection` makes rows clickable + highlights the selected (blue) row;
        // `bulkActions` auto-injects the left checkbox column with parent/child
        // (workspace → entity) selection.
        selection: true,
        bulkActions: true,
        density: ViewDensity.MD,
    },
};
